import { Form } from 'factorial-form'
import { EmployeesEmployeeSelectorInput } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Values {
  employeeSelection?: EmployeesEmployeeSelectorInput
  template_id?: number
}

class ApplyShiftTemplateForm extends Form {
  employeeSelection: EmployeesEmployeeSelectorInput

  constructor(values: Values = {}) {
    super(values, {
      template_id: 'number',
      template_week_position: 'number',
      start_date: 'string',
      end_date: 'string',
      employee_id: 'number',
      notes: 'string',
      location_id: 'number',
      work_area_id: 'number',
    })

    this.employeeSelection = values.employeeSelection ?? { type: 'manual', ids: [] }
  }

  validate(): boolean {
    this.resetErrors()

    if (this.employeeSelection.type === 'manual' && this.employeeSelection?.ids?.length === 0)
      this.get('employee_id').setErrors([
        i18n.t('shift_management.actions_sidepanel.errors.no_employees'),
      ])

    if (!this.get('start_date').hasValue)
      this.get('start_date').setErrors([
        i18n.t('shift_management.actions_sidepanel.errors.no_time_frame'),
      ])

    if (!this.get('end_date').hasValue)
      this.get('end_date').setErrors([
        i18n.t('shift_management.actions_sidepanel.errors.no_time_frame'),
      ])

    if (!this.get('template_id').hasValue || !this.get('template_week_position').hasValue)
      this.get('template_id').setErrors([
        i18n.t('shift_management.actions_sidepanel.errors.no_rotating_shift.title'),
      ])

    return !this.hasErrors
  }
}

export default ApplyShiftTemplateForm
